import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";

export const NOTIFICATION_TABS = [
  { name: "Providers", path: "/notifications/providers" },
  { name: "Message Templates", path: "/notifications/templates" },
  { name: "SMS Gateways", path: "/notifications/sms-gateways" },
  { name: "SMS Charges", path: "/notifications/sms-charges" },
];

// Values are sent verbatim — INIVITE_CONTACT is the backend's spelling and
// must not be "corrected" on the way out.
export const SMS_EVENT_STATUS_OPTIONS = [
  { label: "Transaction", value: "TRANSACTION" },
  { label: "QR Code", value: "QRCODE" },
  { label: "Donate", value: "DONATE" },
  { label: "Bills Payment", value: "BILLSPAYMENT" },
  { label: "Messaging", value: "MESSAGING" },
  { label: "Non-Waya", value: "NONWAYA" },
  { label: "BVN", value: "BVN" },
  { label: "Commission", value: "COMMISSION" },
  { label: "Payment Request", value: "PAYMENT_REQUEST" },
  { label: "Contact", value: "CONTACT" },
  { label: "Invite Contact", value: "INIVITE_CONTACT" },
  { label: "Advert", value: "ADVERT" },
];

export const SMS_EVENT_LABELS = SMS_EVENT_STATUS_OPTIONS.reduce((acc, o) => {
  acc[o.value] = o.label;
  return acc;
}, {});

export const PROVIDER_TYPES = [
  { label: "SMS", value: "sms", icon: <SmsOutlinedIcon fontSize="small" /> },
  { label: "Email", value: "email", icon: <PaidOutlinedIcon fontSize="small" /> },
];

// The API exposes `active` as a boolean; mapped to a status string for the
// shared status chip.
export const ACTIVE_STATUS_STYLES = {
  ACTIVE: { bg: "#ecfdf5", color: "#065f46", dot: "#10b981" },
  INACTIVE: { bg: "#f3f4f6", color: "#374151", dot: "#9ca3af" },
};

export const toActiveStatus = (active) => (active ? "ACTIVE" : "INACTIVE");